import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'
import tailwindMergeConfig from './tailwindMergeConfig'

const twMerge = extendTailwindMerge(tailwindMergeConfig)
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(...inputs))
